import styled from "styled-components"
import { TableBody } from "@material-ui/core"

export const TBody = styled(TableBody)``
